/*
 * Svepbara raders pilknappar.
 *
 * Låg i assets/browse.js till 2026-08-06 (kväll), när startsidans
 * kategorirad behövde exakt samma sak. browse.js laddas bara på kategori-
 * och söksidan och bär filterlogik som startsidan inte har någon nytta av;
 * att ladda hela filen för femtio rader railkod hade varit att betala för
 * fel sak. Filen är därför fristående och inkluderas per sektion, samma
 * mönster som browse.js självt.
 *
 * Raden går alltid att svepa och skrolla utan det här — knapparna är en
 * genväg för pekdon som saknar horisontell gest, och samtidigt det som SÄGER
 * att raden fortsätter. Därför renderas de `hidden` i Liquid och tänds först
 * här: ryms allt utan skroll hade en synlig knapp ljugit.
 */
(function () {
  'use strict';

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  qsa('[data-rail]').forEach(function (wrap) {
    var rail = qs('[data-rail-track], .subcat-rail, .filters__bar', wrap);
    var prev = qs('[data-rail-prev]', wrap);
    var next = qs('[data-rail-next]', wrap);
    if (!rail || !prev || !next) return;

    /* 1 px slack: scrollWidth och clientWidth är avrundade heltal och kan
       skilja sig med en subpixel på en rad som i praktiken ryms. Utan den
       blinkar knappen fram på bredder där det inte finns något att skrolla. */
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      prev.hidden = rail.scrollLeft <= 1;
      next.hidden = rail.scrollLeft >= max - 1;

      /* Wrappern får veta om raden svämmar över alls. Startsidans rad visar
         sina pilar först vid hover, och en hover-yta som aldrig kan ge en
         knapp ska inte reservera plats för en. */
      wrap.classList.toggle('is-scrollable', max > 1);
    }

    function step(direction) {
      /* 80 % av synlig bredd, inte hela: ett helsideshopp lämnar inget kort
         kvar i vyn och kunden tappar var i listan hen var. */
      rail.scrollBy({ left: direction * rail.clientWidth * 0.8, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Bilderna är ofta ocachade vid första mätningen; utan det här mäts raden
       innan de tagit plats och blir för smal. */
    qsa('img', rail).forEach(function (img) {
      if (!img.complete) img.addEventListener('load', sync, { once: true });
    });

    sync();
  });
})();
